"use client";
import SliderNoArrows from "@/components/Carousel/SliderNoArrows";
import PlayerInPage from "@/components/Player/PlayerInPage";
import { testimonialImg } from "@/utils";
import { SwiperSlide } from "swiper/react";
import videoTestimonials from "../../../../public/content/videoTestimonials.json";
import Triangles from "@/components/Triangles";
import Title from "@/components/Text/Title";
import SideBySideText from "@/components/Text/SideBySideText";
import Text from "@/components/Text/Text";
import Image from "next/image";
import Newsletter from "@/components/Cards/Newsletter";
import { NewsletterOrange } from "@/stories/Newsletter.stories";
import Card from "@/components/Cards/Card";
import { TextCard } from "@/stories/Card.stories";
import FAQAccordion from "@/components/FAQAccordion";
import FAQ from "../../../../public/content/FAQ.json";
import { sendGTMEvent } from "@/components/Analytics";

export default function WieFunktioniertsLayout() {
    return (
        <>
            <div className="bg-yellow flex justify-center">
                <div className="container w-full  px-3 md:px-20 pb-24 flex-col justify-center items-center gap-6 inline-flex">
                    <Title
                        hasPreTitle={true}
                        preTitle="WIE FUNKTIONIERTS?"
                        title="So funktioniert die Energiefeld-Instandsetzung"
                        hasSubTitle={true}
                        hasColorTitle={false}
                        hasText={false}
                        subTitle="Durch die Betrachtung und das Verständnis des Energiefeldes beginnt es sich selbst zu reparieren."
                        textColor="text-black"
                        paddings="px-3 pt-24 "
                        subtitleStyle=""
                        subtitleSize="text-xl lg:text-2xl"
                    />

                    <PlayerInPage
                        videoId="afbcf25f5206bc9a2587bbd3da95cbb1"
                        thumbnail="/images/thumbnails/wieFunkThumbnail1.jpg"
                    />
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles backgroundColor="bg-turquoise" buttomToTop={false} />
            </div>
            <div className="bg-turquoise flex justify-center">
                <div className="container w-full  px-3 py-10 lg:py-20 flex-col justify-center items-center gap-6 inline-flex">
                    <Text
                        hasPretitle={false}
                        title="Für ein stabiles Energiefeld"
                        hasSubTitle={true}
                        hasReadMore={true}
                        paragraphSlice={1}
                        subTitle="Während ich an den Ursachen arbeite, unterstütze ich den Prozess, indem ich das gesamte Energiefeld stabilisiere. Auch beruhige ich den überlasteten Teil des Energiefeldes, was die Stabilisierung weiter verbessert, worduch das Energiefeld weniger gestresst ist. "
                        hasText={true}
                        paragraphs={[
                            "",
                            "Dies kann gelegentlich Überforderungen im Energiefeld auslösen. Wenn jedoch das Energiefeld stabiler ist, wird es weniger überfordert.  Im Grunde genommen arbeite ich immer an dem gesamten Energiefeld, außer bei den Energiefeldern, die bereits einwandfrei funktionieren.",
                        ]}
                        subTitleSize="leading-7 text-xl lg:text-2xl"
                        leadingText="leading-7 lg:leading-8.5"
                        leading="leading-10"
                        paddings="px-3 lg:px-74 py-5 md:px-20 lg:py-25 w-full"
                    />
                    <Image alt="" height={500} width={300} src="/images/diagram.svg" />
                </div>
            </div>{" "}
            <div className="bg-turquoise -mb-[0.1rem]">
                <Triangles backgroundColor="bg-yellow" buttomToTop={true} />
            </div>
            <div className="bg-yellow w-full px-6 py-10 flex-col justify-center items-center gap-6 inline-flex">
                <SideBySideText
                    paddings=" py-10 lg:py-25 md:px-0 lg:px-32"
                    reverse={true}
                    backgroundColor="bg-yellow"
                    elementLeft={
                        <div className="pt-5 lg:pt-0">
                            <PlayerInPage
                                videoId="483ede3334c210811f252a8008779569"
                                thumbnail="/images/thumbnails/wieFunkThumbnail2.jpg"
                            />
                        </div>
                    }
                    elementRight={
                        <Title
                            hasColorTitle={false}
                            hasPreTitle={false}
                            hasSubTitle={false}
                            title="Wie ich das Energiefeld stabilisiere "
                            paddings=""
                            text="währenddem ich an den Ursachen arbeite"
                            textAlignment="left"
                            titleSize="text-[40px] lg:text-[80px]"
                            leadingTitle="lg:leading-[80px] leading-[52px]"
                        />
                    }
                />
            </div>
            <div className="bg-yellow -mb-[0.1rem]">
                <Triangles backgroundColor="bg-white" buttomToTop={false} />
            </div>
            <div className="bg-white flex justify-center">
                <div className="container w-full space-y-4 py-20 px-3 gap-6 ">
                    <div className="flex flex-col  justify-start">
                        <p className="lg:text-2xl text-xl text-center lg:text-start  font-bold">
                            Erfahrungsberichte
                        </p>
                        <p className="lg:text-5xl text-xl3 text-center lg:text-start font-bold">
                            Was andere zur Fernbehandlung sagen
                        </p>
                    </div>
                    <div className="lg:block md:block hidden">
                        <SliderNoArrows
                            slidesPerView={1.5}
                            paginationColor="#000"
                            centered={false}
                            contentEl={
                                <div>
                                    {videoTestimonials.videoTestimonials.map(
                                        (testemonial) => (
                                            <SwiperSlide
                                                className="lg:pb-10 pb-2"
                                                key={testemonial.id}
                                            >
                                                <PlayerInPage
                                                    videoId={testemonial.id}
                                                    thumbnail={
                                                        testimonialImg.find(
                                                            (img) =>
                                                                img.name ===
                                                                testemonial.name,
                                                        )?.url
                                                    }
                                                />
                                            </SwiperSlide>
                                        ),
                                    )}
                                </div>
                            }
                        />
                    </div>
                    <div className="lg:hidden md:hidden flex justify-center">
                        <SliderNoArrows
                            slidesPerView={1}
                            paginationColor="#000"
                            centered={false}
                            contentEl={
                                <div>
                                    {videoTestimonials.videoTestimonials.map(
                                        (testemonial) => (
                                            <SwiperSlide
                                                className="lg:pb-10 pb-6"
                                                key={testemonial.id}
                                            >
                                                <PlayerInPage
                                                    videoId={testemonial.id}
                                                    thumbnail={
                                                        testimonialImg.find(
                                                            (img) =>
                                                                img.name ===
                                                                testemonial.name,
                                                        )?.url
                                                    }
                                                />
                                            </SwiperSlide>
                                        ),
                                    )}
                                </div>
                            }
                        />
                    </div>
                </div>
            </div>
            <div className="bg-white -mb-[0.1rem]">
                <Triangles buttomToTop={true} backgroundColor="bg-black" />
            </div>
            <div className="bg-black py-20 flex justify-center">
                <div className="flex  justify-center items-center">
                    <PlayerInPage
                        videoId="dfc4ed71581b71849fdf56312835a706"
                        thumbnail="/images/thumbnails/wieFunkThumbnail3.jpg"
                    />
                </div>
            </div>
            <div className="bg-black -mb-[0.1rem]">
                <Triangles backgroundColor="bg-white" buttomToTop={false} />
            </div>
            <div className="bg-white w-full  px-3 flex-col justify-center items-center gap-6 inline-flex">
                <div className="bg-white space-y-2 w-full px-3 lg:px-20 py-20">
                    <div className="text-left md:text-center lg:text-center text-black text-xl3 lg:text-5xl font-bold  leading-7 lg:leading-14">
                        FAQ
                    </div>

                    <div className="text-left md:text-center lg:text-center text-black text-xl1 font-normal  leading-7 lg:leading-8.5">
                        Hier erhältst du Antworten auf Fragen, wie die Fernbehandlung
                        funktioniert.
                    </div>
                    <div className="flex justify-center items-center my-10">
                        <FAQAccordion
                            // @ts-ignore
                            FAQItem={
                                FAQ.FAQ.find((item) => item.page === "Wie funktioniert")
                                    ?.FAQ
                            }
                            // FAQItem={FAQ}
                        />
                    </div>
                </div>
            </div>
            <div className="bg-white -mb-[0.1rem]">
                <Triangles backgroundColor="bg-black" buttomToTop={true} />
            </div>
            <div className="bg-black w-full  px-3  py-10 lg:py-30 flex-col justify-center items-center gap-6 inline-flex">
                <Card
                    backgroundColor={TextCard.args?.backgroundColor}
                    hasButton={TextCard.args?.hasButton}
                    hasImage={TextCard.args?.hasImage}
                    hasList={TextCard.args?.hasList}
                    hasPretitle={TextCard.args?.hasPretitle}
                    hasText={TextCard.args?.hasText}
                    textSize={TextCard.args?.textSize}
                    titleSize={TextCard.args?.titleSize}
                    pretitle="Mein Bestes geben"
                    height="min-h-[590px] pb-6"
                    pretitleSize="text-[28px] lg:text-xl3 italic"
                    title="Ich gebe kein Heilsversprechen"
                    content="Ich bleibe mit voller Absicht den Beweis schuldig, dass meine Arbeit wirkt. Es gibt sehr viele Menschen, die von meiner Arbeit profitieren konnten. Es gibt aber auch Menschen, die es nicht spüren konnten und das ist in Ordnung. Man kann nicht immer allen Menschen helfen, auch wenn man es möchte. Darum gebe ich keine Versprechen, was den Erfolg meiner Arbeit anbelangt. Ich gebe mein Bestes, anhand meiner Forschungsarbeiten und der daraus resultierenden Energiefeldmechanik, präzise am Energiefeld zu arbeiten und die Ursachen für Probleme zu lösen. Wenn die Energiefelder funktionieren, dann funktioniert das Leben und macht auch wieder Spass."
                />
            </div>
            <div className="bg-black -mb-[0.1rem]">
                <Triangles backgroundColor="bg-orange" buttomToTop={false} />
            </div>
            <div className="bg-orange flex justify-center">
                <div className="container w-full lg:py-20 px-3 flex-col justify-center items-center gap-6 inline-flex">
                    <Newsletter
                        hasCheckbox={NewsletterOrange.args?.hasCheckbox}
                        hasDescription={NewsletterOrange.args?.hasDescription}
                        hasInput={NewsletterOrange.args?.hasInput}
                        hasSubText={NewsletterOrange.args?.hasSubText}
                        backgroundColor={NewsletterOrange.args?.backgroundColor}
                        buttonText={NewsletterOrange.args?.buttonText}
                        checkBoxText={NewsletterOrange.args?.checkBoxText}
                        description={NewsletterOrange.args?.description}
                        title={NewsletterOrange.args?.title}
                        buttonAs="a"
                        href="/de/bestellung-fernbehandlung"
                        paddings="lg:px-80 md:px-20"
                        buttonPaddings="py-4 lg:px-6 px-12 "
                        onClickButton={() => {
                            sendGTMEvent({
                                event: "cta_click",
                                section_title: "Warte nicht länger - pack es an!",
                                section_index: "8",
                                cta_text: "HEUTE NOCH BEGINNEN",
                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/bestellung-fernbehandlung`,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="bg-orange -mb-[0.1rem]">
                <Triangles backgroundColor="bg-darkGray" buttomToTop={true} />
            </div>
        </>
    );
}
